import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from "jodit-react";

function UpdateBlogContent() {
  const editor = useRef(null);
  const navigate = useNavigate();
  const { blogid } = useParams();
  const srno = blogid;
  const [formData, setFormData] = useState({
    postid: "",
    posttitle: "",
    postheading: "",
    author: "",
    content: "",
    featuredimage: "",
    featuredicon: "",
    category: "",
  });

  const [allBlogs, setAllBlogs] = useState([]);
  const callApiBlogContent = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = process.env.REACT_APP_API_URL + "posts/showAll";
      const response = await axios.get(url, { headers });
      setAllBlogs(response.data);
    } catch (error) {
      toast.error("Couldn't Fetch Blog", {
        position: "top-center",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  useEffect(() => {
    if (allBlogs.length === 0) {
      callApiBlogContent();
    }
    const matchingBlog = allBlogs.find(
      (item) => item.srno === parseInt(srno, 10)
    );
    if (matchingBlog) {
      setFormData(matchingBlog);
    }
  }, [srno, allBlogs]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleContentChange = (newContent) => {
    setFormData({ ...formData, content: newContent });
  };

  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const callApiUpdateContent = async () => {
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };

      // point to the 'blog' route to properly use blog crud
      const url = process.env.REACT_APP_API_URL + "blog/updateblog/" + srno;

      await axios.put(url, formData, { headers });
    } catch (err) {
      toast.error("Blog not updated", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setShowUpdateModal(false);
    if (
      !formData.postid ||
      !formData.posttitle ||
      !formData.category ||
      !formData.postheading ||
      !formData.author ||
      !formData.content
    ) {
      toast.error("Missing required parameters.", {
        position: "top-right",
        autoClose: 1000,
        theme: "colored",
      });
    } else {
      try {
        await callApiUpdateContent();
        toast.success("Blog Updated Successfully", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/blogslist");
        }, 2000);
      } catch (error) {
        toast.error("Blog not updated", {
          position: "top-right",
          autoClose: 1000,
          theme: "colored",
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowUpdateModal(true);
  };

  // blog image upload 
  const [image, setImage] = useState('');

  function handleImage(e) {
    console.log(e.target.files[0]);
    setImage(e.target.files[0])
  }

  function handleApi(postid) {
    if (!image) {
      toast.error("Please select a file first");
      return;
    }

    const formDataUpload = new FormData();
    formDataUpload.append('blogpic', image);

    // Using backticks for the URL to ensure postid is injected correctly
    const url = `${process.env.REACT_APP_API_URL}images/uploadImage/blogimages/${postid}`;

    axios.put(url, formDataUpload, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-access-token': localStorage.getItem('jwttoken')
      }
    }).then((res) => {
      // THIS IS THE CRITICAL LINE
      // If your backend returns the path in 'fileLocation', we must save it to state
      if (res.data.fileLocation) {
        setFormData(prev => ({ ...prev, featuredimage: res.data.fileLocation }));
        console.log("Database path prepared:", res.data.fileLocation);

      }

      toast.success("Image Uploaded Successfully", {
        position: "top-center",
        autoClose: 1000,
        theme: "colored",
      });
      setImage('');
    }).catch((err) => {
      console.error("Upload error:", err);
      toast.error("Failed to upload image");
    });
  }

  return (
    <>
      <div className="container mt-4">
        <div className="form-card">
          <div className="form-card-header">
            Update Blog
          </div>
          <div className="form-card-body">
            <Form onSubmit={handleSubmit}>

              {/* Row 1: Post ID & Category */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="postid">
                  <Form.Label>Post Content Id:</Form.Label>
                  <Form.Control
                    type="text"
                    name="postid"
                    value={formData.postid}
                    disabled
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="posttitle">
                  <Form.Label>Post Title:</Form.Label>
                  <Form.Control
                    type="text"
                    name="posttitle"
                    value={formData.posttitle}
                    onChange={handleChange}
                    placeholder="Post Title"
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="category">
                  <Form.Label>Category:</Form.Label>
                  <Form.Control
                    type="text"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    placeholder="Category"
                    maxLength={100}
                  />
                </Form.Group>
              </Row>

              {/* Row 2: Heading & Author */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="postheading">
                  <Form.Label>Post Heading:</Form.Label>
                  <Form.Control
                    type="text"
                    name="postheading"
                    value={formData.postheading}
                    onChange={handleChange}
                    placeholder="Post Content Heading"
                    maxLength={100}
                  />
                </Form.Group>
                <Form.Group as={Col} controlId="author">
                  <Form.Label>Post Author:</Form.Label>
                  <Form.Control
                    type="text"
                    name="author"
                    value={formData.author}
                    onChange={handleChange}
                    placeholder="Post Author"
                    maxLength={100}
                  />
                </Form.Group>
              </Row>

              {/* Content Editor */}
              <Form.Group className="mb-3" controlId="content">
                <Form.Label>Content:</Form.Label>
                <JoditEditor
                  ref={editor}
                  value={formData.content}
                  className="form-control"
                  name="content"
                  onChange={handleContentChange}
                />
              </Form.Group>

              {/* Image Upload Section */}
              <Row className="mb-3">
                <Form.Group as={Col} controlId="imageUpload">
                  <Form.Label>Upload Featured Image (Optional):</Form.Label>
                  <Form.Control type="file" onChange={handleImage} />
                  <button
                    type="button"
                    onClick={() => handleApi(formData.postid)}
                    className='btn-gradient-success mt-2'
                    disabled={!image}
                  >
                    Upload Image
                  </button>
                </Form.Group>
                <Col>
                  {formData.featuredimage && (
                    <div className="image-preview-container">
                      <Form.Label>Current Image:</Form.Label>
                      <div>
                        <img
                          src={formData.featuredimage.startsWith('http') ? formData.featuredimage : `${process.env.REACT_APP_API_URL}${formData.featuredimage}`}
                          alt="Featured"
                          loading="lazy"
                          className="image-preview"
                        />
                        <span className="image-preview-label">{formData.featuredimage}</span>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>

              {/* Form Actions */}
              <div className="form-actions">
                <button type="submit" className="btn-gradient-primary">
                  Update Blog
                </button>
                <Link to="/blogslist" className="btn-back-link">
                  ← Back to List
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>

      <ToastContainer />

      {/* Update Confirmation Modal */}
      <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Blog Update</Modal.Title>
        </Modal.Header>
        <Modal.Body>Sure you want to update blog?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowUpdateModal(false)}>
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleUpdate}
            variant="primary"
            style={{ marginLeft: "10px" }}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UpdateBlogContent;